import {
  createRouter,
  Register
} from '@tanstack/react-router';

import { queryClient } from '@/app/lib/tanstack-query';
import { routeTree } from '@/app/routeTree.gen';
import { PageLoader } from '@/common/components/page-loader';

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
    ensureUser: undefined!
  },
  // allows any errors thrown not caught by specific routes to be tossed to the higher boundaries
  disableGlobalCatchBoundary: true,
  defaultPendingComponent: PageLoader,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/**
 * Application router context.
 */
export type AppRouterContext = Register['router']['options']['context'];

export function routeMetadata(title: string) {
  return [
    { title: `${title} | myTalquin Member Portal` }
  ];
}
